import { PapiDeviation } from '@wix/da-papi-types';
import { useDeviationMatureFilter } from '../../../utils/hooks/useDeviationMatureFilter';
import { useSubscriptionTier } from '../../../utils/hooks/useSubscriptionTier';
import { normalizePremiumFolderData } from '../../../utils/normalizePremiumFolderData';
import { useOverlayContext } from '../../hooks/useOverlayContext';

export function useDeviationBlockType(deviation: PapiDeviation) {
  const { showPremiumFolderOverlay, showSubscriberOverlay } =
    useOverlayContext(deviation);
  const { isPremiumLocked, isPaidFolder, isWatchToAccess } =
    normalizePremiumFolderData(deviation?.premiumFolderData);
  const { needsSubscription, isSubscribedButBlocked } =
    useSubscriptionTier(deviation);
  const { showBlocked } = useDeviationMatureFilter(deviation);

  if (showBlocked) {
    return 'matureFilter';
  }

  if (isPremiumLocked && isPaidFolder && showPremiumFolderOverlay) {
    return 'premiumFolder';
  }

  if (isPremiumLocked && isWatchToAccess && showPremiumFolderOverlay) {
    return 'watchersOnly';
  }

  if (needsSubscription && showSubscriberOverlay) {
    return 'subsOnly';
  }

  if (isSubscribedButBlocked && showSubscriberOverlay) {
    return 'subBlocked';
  }
}
